import React, {createContext} from 'react';
export const LocationContext = createContext()
export function LocationProvider(props) {
   return  <LocationContext.Provider {...props} />;
}



